import React, { useEffect, useState } from "react";

import { useAxiosContext } from "../../../../context/AxiosContext";
import { useModalContext } from "../../../../context/ModalContext";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import UserForm from "../UserForm";
import UserCard from "./UserCard";

const DBUser = ({ selectedConnectorId }) => {
  const [users, setUsers] = useState([]);
  // const { user } = useAuth0Context();
  const [isOpen, setIsOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const { getUserConfirmationForDelete } = useModalContext();

  const setIsOpenCallback = (isOpen) => {
    setIsOpen(isOpen);
  };

  const setIsEditOpenCallback = (isOpen) => {
    setIsEditOpen(isOpen);
  };

  const setUsersCallback = (users) => {
    setUsers(users);
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setIsEditOpen(true);
  };

  const handleDeleteClick = async (id, name) => {
    const userConfirmed = await getUserConfirmationForDelete(name);
    if (!userConfirmed) return;

    try {
      const { message } = await axiosInstance.delete(`/dbuser/${id}/connector/${selectedConnectorId}`);
      handleSuccess(message);
      setUsers((prev) => prev.filter((user) => user.user_id !== id));
    } catch (error) {
      handleError(error);
    }
  };

  const fetchUsers = async () => {
    try {
      const { data } = await axiosInstance.get(`/dbuser/connector/${selectedConnectorId}`);

      setUsers(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    fetchUsers();

    //eslint-disable-next-line
  }, []);

  return (
    <div className="group_card_container p_3">
      <UserCard add={true} setIsOpenCallback={setIsOpenCallback} />
      {users.length > 0 ? (
        users.map((user) => (
          <UserCard key={user.id} user={user} onDelete={handleDeleteClick} onEdit={handleEditClick} />
        ))
      ) : (
        <p>No Users Available</p>
      )}

      <BuilderModal isOpen={isOpen} modalName="Add DB User" onClose={() => setIsOpen(false)}>
        <UserForm
          isEdit={false}
          users={users}
          selectedConnectorId={selectedConnectorId}
          setIsOpenCallback={setIsOpenCallback}
          setUsersCallback={setUsersCallback}
        />
      </BuilderModal>

      <BuilderRightSideBar
        isOpen={isEditOpen}
        heading="Edit DB User"
        onClose={() => setIsEditOpen(false)}
        bodyClass="p_3"
      >
        <UserForm
          isEdit={true}
          users={users}
          selectedConnectorId={selectedConnectorId}
          setIsOpenCallback={setIsEditOpenCallback}
          selectedUser={selectedUser}
          setUsersCallback={setUsersCallback}
          edit={true}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default DBUser;
